import { render, staticRenderFns } from "./imprImmediate.vue?vue&type=template&id=1d2e5c7e"
import script from "./imprImmediate.vue?vue&type=script&lang=js"
export * from "./imprImmediate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d2e5c7e')) {
      api.createRecord('1d2e5c7e', component.options)
    } else {
      api.reload('1d2e5c7e', component.options)
    }
    module.hot.accept("./imprImmediate.vue?vue&type=template&id=1d2e5c7e", function () {
      api.rerender('1d2e5c7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/ibm/imprImmediate.vue"
export default component.exports